















import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
@Component({
    name: 'EnterpriseTypeCount',
    components : {},
})
export default class EnterpriseTypeCount extends Vue {
  private show: any = false;
  private enterpriseTypeCount: any = [];
  @Watch('$store.state.searchStore.enterpriseTypeCount')
  private getData(data: any) {
    if (data.length > 0) {
      this.show = true;
      this.enterpriseTypeCount = data;
    } else {
      this.show = false;
    }
  }
}
